//接口
export default {
	//医院
	hospital:{
		hospitalInfo:"/open/hospital/detail",//获取医院详细信息-医院
		doctors:"/open/doctor/page",//分页获取医生列表-医院
		recommendDoctors:"/open/doctor/recommend",//分页获取医生列表-医院
    orgRecommendDoctors:"/open/doctor/orgRecommend",//分页获取医生列表-医院
		depts:'/open/hospital/depts',//获取科室信息
		hospital:'/open/hospital/page',//分页获取医院
		doctordetail:'/open/doctor/detail',//医生详情
		pageComment:'/open/doctor/pageComment',//分页获取评价
    dept:'/open/dept/list',//科室
	},
	//互联网医院
	onlinehospital:{
		discoverys:'/open/discovery/page',//分页获取资讯-首页
    discoveryss:'/open/discovery/page',//分页获取资讯-首页
    newsinfo:'/open/discovery/info',//获取资讯详情
		addread:'/open/discovery/addread',//分页获取资讯-阅读数量-首页
		banner:'/open/banner/list',//获取banner列表-首页
	}
}



// WEBPACK FOOTER //
// ./src/utils/api.js